<template>
  <section class="content">
    <div class="row center-block">
      <box title="Clique para selecionar os clientes que deseja notificar">
        <!-- /.box-header -->
        <div slot="body">
          <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
            <div class="row">
              <div class="col-md-6">
                <a href="javascript:void();" @click="selecionarTodos">Selecionar Todos ({{clientes.length}}) >></a><br>
                <input type="text" placeholder="Pesquisar" class="form-control" style="width: 100%;" v-model="filter1">
                <ul class="list-group groupNotifica">
                  <li class="list-group-item itemNotificar" v-for="(element, index) in usersFiltered1" :key="index"
                    @click="selecionar(element)">
                    {{nome(element.nome, element.sobrenome)}} - {{element.fb_id ? element.fb_id : element.facebook_id}}
                  </li>
                </ul>
              </div>
              <div class="col-md-6">
                <a href="javascript:void();" @click="removerTodos">{{`<< Remover Todos`}} ({{notificar.length}})
                </a><br>
                <input type="text" placeholder="Pesquisar" class="form-control" style="width: 100%;" v-model="filter2">
                <ul class="list-group groupNotifica">
                  <li class="list-group-item itemNotificar" v-for="(element, index) in usersFiltered2" :key="index"
                    @click="remover(element)">
                    {{nome(element.nome, element.sobrenome)}} - {{element.fb_id ? element.fb_id : element.facebook_id}}
                  </li>
                </ul>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-12">
                <label for="comment">Texto da notificação:</label><br>
                <textarea class="form-control" rows="2" style="width: 100%" v-model="msg" maxlength="240"></textarea>
                <span id="cont">{{msg.length}}/240</span>
              </div>
            </div><br>
            <div class="row">
              <div class="col-sm-12">
                <label for="comment" style="padding-right: 10px">Enviar botões ?</label>
                <toggle-button v-model="enviarReplies" :color="color" :sync="true" />
              </div>
              <div class="col-sm-12" v-show="enviarReplies">
                <div class="checkbox">
                  <label><input type="checkbox" value="cardapio" v-model="replies">Ver Cardápio</label>
                </div><br>
                <div class="checkbox">
                  <label><input type="checkbox" value="pergunta" v-model="replies">Fazer Pergunta</label>
                </div>
              </div>
            </div><br><br>
            <div class="row">
              <div class="col-md-12">
                <router-link class="pageLink" to="/clientes">
                  <button class="btn btn-danger">Cancelar</button>
                </router-link>
                <button class="btn btn-success" @click="notificarClientes" v-show="notificar.length > 0 && msg">
                  <i class="fa fa-check"> Enviar Notificação</i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </box>


    </div>
  </section>
</template>

<script>
  import axios from 'axios'
  import Box from './Box'
  import draggable from 'vuedraggable'

  // import routes from '../../routes.js'

  export default {
    name: 'Ordenarprodutos',
    components: {
      'box': Box,
      draggable,
    },
    data() {
      return {
        clientes: [],
        notificar: [],
        editable: true,
        isDragging: false,
        delayedDragging: false,
        filter1: '',
        filter2: '',
        msg: '',
        enviarReplies: false,
        replies: []
      }
    },
    created() {
      console.log('CREATEEE ==> ', this.$route.params)
      this.clientes = this.$route.params.clientes
      if(this.$route.params.cupom) {
        let tipoDesc = this.$route.params.tipo === 'frete' ? 'Frete grátis' : (this.$route.params.tipo === 'porcentagem' ? `${this.$route.params.desconto}% de desconto` : `R$${this.$route.params.desconto} de desconto`)
        this.msg = `Utilize o cupom '${this.$route.params.cupom.toUpperCase()}' para receber ${tipoDesc}`
      }
    },
    methods: {
      onMove({
        relatedContext,
        draggedContext
      }) {
        const relatedElement = relatedContext.element;
        const draggedElement = draggedContext.element;
        return (
          (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
        );
      },
      nome(nome, sobrenome) {
        return `${nome} ${sobrenome}`
      },
      selecionarTodos() {
        this.clientes.forEach(element => {
          this.notificar.push(element);
        });
        this.clientes = []
      },
      removerTodos() {
        this.notificar.forEach(element => {
          this.clientes.push(element);
        });
        this.notificar = []
      },
      selecionar(cliente) {
        let cliente_id = cliente.fb_id ? cliente.fb_id : cliente.facebook_id
        this.clientes.forEach((element, index) => {
          let fb_id = element.fb_id ? element.fb_id : element.facebook_id
          if (fb_id === cliente_id) {
            this.notificar.push(cliente);
            this.clientes.splice(index, 1);
            return;
          }
        });
      },
      remover(cliente) {
        let cliente_id = cliente.fb_id ? cliente.fb_id : cliente.facebook_id
        this.notificar.forEach((element, index) => {
          let fb_id = element.fb_id ? element.fb_id : element.facebook_id
          if (fb_id === cliente_id) {
            this.clientes.push(cliente);
            this.notificar.splice(index, 1);
            return;
          }
        });
      },
      notificarClientes() {
        if (!this.enviarReplies) this.replies = []
        let url = `${this.$store.state.api_bot}notificar`
        let ids = this.notificar.map(el => el.id);
        console.log('notificar => ', ids)
        // this.notificar.forEach(element => {
        //   console.log('element to notify => ', element)
        axios.post(url, {
          ids,
          'msg': this.msg,
          'replies': this.replies
        })
        // });
        this.$swal({
          position: 'top-end',
          type: 'success',
          title: 'Clientes Notificados',
          showConfirmButton: false,
          timer: 1500
        });
        this.$router.go(-1)
      }
    },
    computed: {
      dragOptions() {
        return {
          animation: 0,
          group: "description",
          disabled: !this.editable,
          ghostClass: "ghost"
        };
      },
      usersFiltered1() {
        return _.filter(this.clientes, item => {
          let nome = `${item.nome.toUpperCase()} ${item.sobrenome.toUpperCase()}`;
          return nome.indexOf(this.filter1.toUpperCase()) >= 0
        })
      },
      usersFiltered2() {
        return _.filter(this.notificar, item => {
          let nome = `${item.nome.toUpperCase()} ${item.sobrenome.toUpperCase()}`;
          return nome.indexOf(this.filter2.toUpperCase()) >= 0
        })
      }
    },
    watch: {
      isDragging(newValue) {
        if (newValue) {
          this.delayedDragging = true;
          return;
        }
        this.$nextTick(() => {
          this.delayedDragging = false;
        });
      }
    }
  }
</script>
<style>
  .flip-list-move {
    transition: transform 0.5s;
  }

  .no-move {
    transition: transform 0s;
  }

  .ghost {
    opacity: 0.5;
    background: #c8ebfb;
  }

  .list-group {
    min-height: 20px;
  }

  .itemNotificar {
    cursor: pointer;
  }

  .list-group-item i {
    cursor: pointer;
  }

  .groupNotifica {
    overflow: auto;
    max-height: 500px;
  }
</style>


// WEBPACK FOOTER //
// NotificarClientes.vue?26739f80